import styled from 'styled-components';
import { themeGet } from '@magalu/stereo-ui-styles';
import { Box } from '@magalu/stereo-ui/atoms';
export const Container = styled(Box)`
  > *:not(:last-child) {
    border-bottom: ${themeGet('borders.0')};
  }
`;